// extracted by mini-css-extract-plugin
export default {"title":"VKeYVCskZzrJe_0FUmFc"};